import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Permission } from 'src/app/user-management/shared/models/permission';
import { UserPermission } from 'src/app/user-management/user-management-setup/models/user';
import { BaseApi } from '../api/base-api';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    constructor(private baseApi: BaseApi, private router: Router) { }

    isUserHasPermission(checkingPermission: Permission): boolean {
        const userPermissions: UserPermission[] = this.baseApi.getUserPermissionsSession();
        const key = checkingPermission.PermissionKey;
        const type = checkingPermission.PermissionType;
        let foundPermission = userPermissions.find(x => x.label === key);
        if (foundPermission) {
            if (Object.getOwnPropertyNames(foundPermission).find(x => x === type)) {
                return foundPermission[type] ? true : false;
            }
            return false;
        }
        return false;
    }
}
